import React, { useState, useRef } from 'react';
import './App.css';
import OverlayInfo from './components/OverlayInfo';
import OverlayBienvenida from './components/OverlayBienvenida';
import OverlayHogar from './components/OverlayHogar';
import OverlayInterior from './components/OverlayInterior';
import OverlayVistaAerea from './components/OverlayVistaAerea';
import OverlayAmbiente from './components/OverlayAmbiente';
import ContactForm from './components/ContactForm';
import WelcomeDialog from './components/WelcomeDialog';

const videos = [
  {
    src: process.env.PUBLIC_URL + '/videos/1.mp4',
    info: { title: 'Video 1', description: 'Descripción del primer video local.' }
  },
  {
    src: process.env.PUBLIC_URL + '/videos/2.mp4',
    info: { title: 'Video 2', description: 'Descripción del segundo video local.' }
  },
  {
    src: process.env.PUBLIC_URL + '/videos/3.mp4',
    info: { title: 'Video 3', description: 'Descripción del tercer video local.' }
  },
  // Videos de interior
  {
    src: process.env.PUBLIC_URL + '/videos/sala.mp4',
    info: { title: 'Sala', description: 'Explora el salón principal de tu nuevo hogar.' },
    ambiente: 'Sala'
  },
  {
    src: process.env.PUBLIC_URL + '/videos/Dormitorio.mp4',
    info: { title: 'Dormitorio', description: 'Descubre el espacio íntimo de tu dormitorio.' },
    ambiente: 'Dormitorio'
  },
  {
    src: process.env.PUBLIC_URL + '/videos/patio.mp4',
    info: { title: 'Patio', description: 'Conoce el patio y áreas exteriores de Garden.' },
    ambiente: 'Patio'
  },
  // Video de vista aérea
  {
    src: process.env.PUBLIC_URL + '/videos/5.mp4',
    info: { title: 'Vista aérea', description: 'Recorre la vista aérea y descubre los planos de tu nuevo hogar.' }
  }
  ,
  // Video Sala 2 (nuevo)
  {
    src: process.env.PUBLIC_URL + '/videos/sala2.mp4',
    info: { title: 'Sala', description: 'Una nueva perspectiva de tu espacio de reunión.' },
    ambiente: 'Sala'
  }
];

function App() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState('forward');
  const [showOverlay, setShowOverlay] = useState(false);
  const [fromNavbar, setFromNavbar] = useState(false);
  const [showExploracion, setShowExploracion] = useState(false);
  const [showWelcomeDialog, setShowWelcomeDialog] = useState(true);
  const videoRefs = useRef(videos.map(() => React.createRef()));

  // Manejar el final del video (solo hacia adelante)
  const handleVideoEnd = () => {
    setShowOverlay(true);
  };

  // Reproducir video hacia adelante
  const playForward = (idx) => {
    const video = videoRefs.current[idx].current;
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  };

  // Pausar video en su último frame
  const pauseAtEnd = (idx) => {
    const video = videoRefs.current[idx].current;
    if (video) {
      const seekToEnd = () => {
        const duration = video.duration;
        if (Number.isFinite(duration) && duration > 0) {
          video.currentTime = duration;
          video.pause();
          return true;
        }
        return false;
      };

      // Intento inmediato
      if (seekToEnd()) return;

      // Esperar a metadata si aún no está disponible
      const onLoaded = () => {
        seekToEnd();
        video.removeEventListener('loadedmetadata', onLoaded);
        video.removeEventListener('loadeddata', onLoaded);
        video.removeEventListener('canplay', onLoaded);
      };
      video.addEventListener('loadedmetadata', onLoaded, { once: true });
      video.addEventListener('loadeddata', onLoaded, { once: true });
      video.addEventListener('canplay', onLoaded, { once: true });
    }
  };

  // Botón siguiente
  const handleNext = () => {
    if (showOverlay) {
      if (current < videos.length - 1) {
        setCurrent(current + 1);
        setDirection('forward');
        setShowOverlay(false);
        setTimeout(() => playForward(current + 1), 100);
      }
    } else {
      setDirection('forward');
      playForward(current);
    }
  };

  // Cerrar overlay de información
  const handleCloseOverlay = () => {
    setShowOverlay(false);
  };

  // Función para cambiar al video de interior específico
  const handleInteriorVideo = (videoIndex) => {
    setCurrent(videoIndex);
    setDirection('forward');
    setShowOverlay(false);
    setTimeout(() => playForward(videoIndex), 100);
  };

  // Función para volver al overlay de interiores desde un ambiente
  const handleVolverAInteriores = () => {
    setCurrent(2); // Índice del overlay de interiores
    setDirection('backward');
    setShowOverlay(true);
    setShowExploracion(true); // Mostrar el estado de exploración
    setTimeout(() => pauseAtEnd(2), 100);
  };

  // Función para manejar el envío del formulario de contacto
  const handleContactSubmit = (formData) => {
    // Aquí puedes implementar la lógica para enviar el formulario
    console.log('Formulario enviado:', formData);
    // Por ahora solo mostramos un alert
    alert('¡Gracias por tu interés! Nos pondremos en contacto contigo pronto.');
  };

  // Cuando cambia el video actual
  React.useEffect(() => {
    if (!showOverlay && direction === 'forward') {
      playForward(current);
    }
    if (direction === 'backward') {
      pauseAtEnd(current);
    }
    // Si venimos del menú y estamos en vista aérea, pausar en el último frame (robusto)
    if (fromNavbar && current === 6) {
      pauseAtEnd(6);
    }
    // Si venimos desde Hogar (no navbar) y estamos en vista aérea, reproducir desde el inicio
    if (!fromNavbar && current === 6) {
      const video = videoRefs.current[6]?.current;
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    }
    // eslint-disable-next-line
  }, [current]);

  return (
    <div className="App">
      {/* Welcome Dialog - aparece al cargar la app */}
      {showWelcomeDialog && (
        <WelcomeDialog onClose={() => setShowWelcomeDialog(false)} />
      )}
     
      <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
        {videos.map((video, idx) => (
          <video
            key={idx}
            ref={videoRefs.current[idx]}
            src={video.src}
            width="100%"
            height="100%"
            style={{
              objectFit: 'cover',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1,
              opacity: idx === current ? 1 : 0,
              pointerEvents: idx === current ? 'auto' : 'none',
              transition: 'opacity 0.3s'
            }}
            onEnded={direction === 'forward' ? handleVideoEnd : undefined}
            muted
            preload="auto"
            playsInline
          />
        ))}
        {/* Overlay de información al terminar */}
        {showOverlay && current === 0 && (
          <OverlayBienvenida onClose={handleNext} />
        )}
        {showOverlay && current === 1 && (
          <OverlayHogar 
            onContinue={handleNext} 
            onVerPlanos={() => {
              setCurrent(6);
              setDirection('forward');
              setShowOverlay(true);
              setFromNavbar(false);
            }}
            onBackClick={() => {
              setCurrent(0);
              setDirection('backward');
              setShowOverlay(true);
              setTimeout(() => pauseAtEnd(0), 100);
            }}
          />
        )}
        {showOverlay && current === 2 && (
          <OverlayInterior 
            onContinue={handleNext} 
            setVideoFondo={handleInteriorVideo}
            showExploracion={showExploracion}
            setShowExploracion={setShowExploracion}
            onClose={() => {
              setCurrent(1);
              setDirection('backward');
              setShowOverlay(true);
              setFromNavbar(false);
              setTimeout(() => pauseAtEnd(1), 100);
            }}
          />
        )}
        {showOverlay && current === 6 && (
          <OverlayVistaAerea onClose={() => {
            setCurrent(1);
            setDirection('backward');
            setShowOverlay(true);
            setFromNavbar(false);
            setTimeout(() => pauseAtEnd(1), 100);
          }} />
        )}
        {/* Overlays específicos para ambientes */}
        {showOverlay && current === 3 && (
          <OverlayAmbiente ambiente="Family Room" onClose={handleVolverAInteriores} />
        )}
        {showOverlay && current === 4 && (
          <OverlayAmbiente ambiente="Dormitorio" onClose={handleVolverAInteriores} />
        )}
        {showOverlay && current === 5 && (
          <OverlayAmbiente ambiente="Patio" onClose={handleVolverAInteriores} />
        )}
        {showOverlay && current === 7 && (
          <OverlayAmbiente ambiente="Sala" onClose={handleVolverAInteriores} />
        )}
        {showOverlay && current === 9 && (
          <div className="overlay-contacto">
            <div className="overlay-contacto-content">
              <div className="contacto-header">
                <img
                  src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
                  alt="Logo Garden"
                  className="contacto-logo"
                />
                <h1>Contacto</h1>
              </div>
              
              <div className="contacto-main">
                <div className="contacto-info">
                  <div className="contacto-seccion">
                    <h3>Ventas – Santiago De Los Caballeros</h3>
                    <p>
                      <a href="https://maps.google.com/?q=Av.+Hispanoamericana,+Santiago+de+los+Caballeros+51000" target="_blank" rel="noopener noreferrer">
                        Av. Hispanoamericana, Santiago de los Caballeros 51000
                      </a>
                    </p>
                    <p>
                      <a href="tel:809-489-7007">809-489-7007</a><br/>
                      <a href="tel:315-502-1414">Desde EEUU sin cargo: 315-502-1414</a>
                    </p>
                  </div>

                  <div className="contacto-seccion">
                    <h3>Oficinas Corporativas – GRUPO ESTRELLA</h3>
                    <p>
                      <a href="https://maps.google.com/?q=Autopista+Duarte+KM+13,+Santiago" target="_blank" rel="noopener noreferrer">
                        Autopista Duarte KM 13, Santiago
                      </a>
                    </p>
                    <p><a href="tel:809-247-3434">809-247-3434</a></p>
                  </div>

                  <div className="contacto-seccion">
                    <h3>Oficina Administrativa Santo Domingo</h3>
                    <p>
                      <a href="https://maps.google.com/?q=Av.+Lope+de+Vega+No.+35,+Santo+Domingo" target="_blank" rel="noopener noreferrer">
                        Av. Lope de Vega No. 35, Santo Domingo
                      </a>
                    </p>
                    <p><a href="tel:809-541-8000">809-541-8000</a></p>
                  </div>

                  <div className="contacto-redes">
                    <a href="https://instagram.com/garden" target="_blank" rel="noopener noreferrer" className="red-social">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://facebook.com/garden" target="_blank" rel="noopener noreferrer" className="red-social">
                      <i className="fab fa-facebook"></i>
                    </a>
                  </div>
                </div>

                <div className="contacto-formulario">
                  <ContactForm onSubmit={handleContactSubmit} />
                </div>
              </div>

              <div className="contacto-creditos">
                <p>Gerencia | Diseño | Ventas | Construcción | por: <strong>ESTRELLA</strong></p>
              </div>
            </div>
          </div>
        )}
        {showOverlay && current !== 0 && current !== 1 && current !== 2 && current !== 3 && current !== 4 && current !== 5 && current !== 6 && current !== 7 && current !== 9 && (
          <OverlayInfo info={videos[current].info} onClose={handleCloseOverlay} />
        )}
      </div>
      <div style={{ position: 'fixed', bottom: 40, left: 0, width: '100%', display: 'flex', justifyContent: 'center', gap: 24, zIndex: 10 }}>
      
      </div>
    </div>
  );
}

export default App;

